export function stripWhitespaceAndNewlines(html: string) {
  return html.replace(/(\r\n|\n|\r|&nbsp;|\t)?/gm, "");
}
